import styled from "@emotion/styled";

/** รูปแบบเดียวกับ OrderPrepareShip — พื้นหลังเทา + แถบค้นหา + ตารางขาว */
export const ParcelWrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
  background-color: #efefef;
`;

/** รูปแบบเดียวกับ OrderPrepareShip/HeadWrapper */
export const ParcelHeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;

export const ParcelCardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;

  /* เนื้อหาในแต่ละแถวชิดขอบบน (เช่น ที่อยู่หลายบรรทัด) */
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    vertical-align: top;
  }
`;

export const ParcelRightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

/** รูปแบบเดียวกับ CreateProduct — พื้นหลังเทา + การ์ดขาวแยกส่วน */
export const ParcelFormOuter = styled.div`
  width: 100%;
  height: 100%;
  background-color: #efefefef;
  padding: 12px 20px 80px 20px;
`;

/** ระยะห่างแนวตั้งระหว่างการ์ด / แถว — ใช้ค่าเดียวทั้งฟอร์ม */
export const PARCEL_FORM_STACK_GAP = 12;

export const PARCEL_FORM_ROW_GUTTER: [number, number] = [
  PARCEL_FORM_STACK_GAP,
  PARCEL_FORM_STACK_GAP,
];

export const ParcelFormStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${PARCEL_FORM_STACK_GAP}px;
  width: 100%;
`;

export const ParcelFormSection = styled.div`
  width: 100%;
  background-color: #ffffff;
  padding: 24px 28px 20px 28px;
  margin-bottom: 0;
  border-radius: 8px;
  box-sizing: border-box;
`;

/** การ์ดในแถวคู่ — ยืดความสูงเท่ากัน ไม่มี margin ซ้ำ */
export const ParcelFormSectionInRow = styled(ParcelFormSection)`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

/** โซนเนื้อหาภายในการ์ดเดียว (ไม่มีพื้นหลัง/ขอบแยก) */
export const ParcelFormZone = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

/** เส้นแบ่งระหว่างโซนในฟอร์มเดียวกัน */
export const ParcelFormZoneDivider = styled.div`
  width: 100%;
  flex-shrink: 0;
  border-top: 1px solid #f0f0f0;
  margin: 20px 0;
`;

/** ข้อความล็อกขั้นตอน — อยู่ในการ์ดด้านบน */
export const ParcelFormLockHint = styled.div`
  margin: 0 0 12px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.45);
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
`;

/** กรอบข้อความแนะนำ (Hint) — เน้นสีฟ้าเพื่อให้เห็นชัด */
export const ParcelHintBox = styled.div`
  margin: 0 0 12px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 1.5;
  color: #000;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 6px;
  box-sizing: border-box;

  /* บังคับให้ text เป็นสีดำ แม้ component จะใช้ type="secondary" */
  & .ant-typography,
  & .ant-typography-secondary {
    color: #000 !important;
  }
`;

/** แจ้งให้ค้นหาที่อยู่ผู้รับใหม่ — เมื่อเบอร์ไม่ตรงกับผลค้นหา */
export const ParcelSearchAgainBox = styled.div`
  margin: 0 0 12px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 1.5;
  color: #cf1322;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  box-sizing: border-box;

  & .ant-typography,
  & .ant-typography-secondary {
    color: #cf1322 !important;
  }
`;

/** ใช้กับ Col ในแถวคู่ */
export const parcelFormColStyle = {
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "stretch" as const,
};

export const ParcelFormSectionTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.85);
`;

/** หัวข้อส่วน + ปุ่มด้านขวา (แนวเดียวกัน) */
export const ParcelFormSectionHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
`;

export const ParcelFormFooterBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 0;
  padding: 16px 28px;
  background-color: #fff;
  border-radius: 8px;
  box-sizing: border-box;
`;

export const ParcelFormFooterActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  align-items: center;
`;

/** ความสูงเดียวกับ Input ข้อความในแถบค้นหาคำสั่งซื้อ (32px) */
export const PARCEL_FIELD_HEIGHT = 32;

/** จำกัดความยาวชื่อผู้รับ / ที่อยู่ปลายทาง */
/** ชื่อผู้รับ — สอดคล้อง Speed / BE validation */
export const PARCEL_DESTINATION_FULLNAME_MAX_LENGTH = 50;
/** ที่อยู่ (บ้านเลขที่ ซอย ถนน) */
export const PARCEL_DESTINATION_ADDRESS_MAX_LENGTH = 100;

export const parcelInputStyle = { height: PARCEL_FIELD_HEIGHT };

export const parcelFullWidthStyle = { width: "100%", height: PARCEL_FIELD_HEIGHT };

/** ปุ่มค้นหาเน้น (เหลือง) — ค้นหาที่อยู่ / ค้นหาบริษัทขนส่ง */
export const parcelHighlightActionButtonStyle = (active: boolean) =>
  active
    ? {
        background: "#faad14",
        borderColor: "#faad14",
        color: "#1f1f1f",
        fontWeight: 500,
      }
    : undefined;

/** ปุ่มไอคอนในตาราง / modal ผลลัพธ์ — กรอบเทา ไม่ใช้สี primary */
export const parcelIconActionButtonStyle = {
  paddingInline: 4,
  width: 28,
  height: 28,
  color: "rgba(0,0,0,0.65)",
  border: "1px solid #d9d9d9",
  background: "#fff",
} as const;

/** ปุ่มไอคอนในตารางรายการ — เล็กกว่า modal (อ้างอิง printShippingLabel) */
export const parcelTableIconActionButtonStyle = {
  paddingInline: 0,
  width: 22,
  height: 22,
  minWidth: 22,
  fontSize: 10,
  lineHeight: 1,
  color: "rgba(0,0,0,0.65)",
  border: "1px solid #d9d9d9",
  background: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
} as const;

/** ขนาดตัวอักษรในตาราง — สอดคล้อง TrackTableList */
export const PARCEL_TABLE_FONT = 12;
export const PARCEL_TABLE_FONT_SECONDARY = 11;
export const PARCEL_TABLE_SECONDARY_COLOR = "rgba(0,0,0,0.6)";

/**
 * ครอบฟอร์มสร้างพัสดุ — ความสูง Input / Select / InputNumber เท่าช่อง「ชื่อผู้รับ」(32px)
 * ยกเว้น TextArea ที่อยู่ (class parcel-field-address-textarea)
 */
export const ParcelFormControlsScope = styled.div`
  /* --- Input บรรทัดเดียว (อ้างอิงชื่อผู้รับ) --- */
  .ant-form-item .ant-input:not(textarea),
  .parcel-field-input.ant-input {
    height: ${PARCEL_FIELD_HEIGHT}px;
  }

  /* --- Select (จังหวัด / บรรจุภัณฑ์ ฯลฯ) --- */
  .ant-form-item .ant-select:not(.ant-select-multiple) .ant-select-selector,
  .parcel-field-select.ant-select:not(.ant-select-multiple) .ant-select-selector {
    height: ${PARCEL_FIELD_HEIGHT}px !important;
    display: flex;
    align-items: center;
  }

  .ant-form-item .ant-select-single .ant-select-selection-item,
  .ant-form-item .ant-select-single .ant-select-selection-placeholder,
  .parcel-field-select.ant-select-single .ant-select-selection-item,
  .parcel-field-select.ant-select-single .ant-select-selection-placeholder {
    line-height: ${PARCEL_FIELD_HEIGHT - 2}px;
  }

  .parcel-field-select.ant-select-multiple .ant-select-selector {
    min-height: ${PARCEL_FIELD_HEIGHT}px !important;
    height: auto !important;
    padding-top: 2px;
    padding-bottom: 2px;
    display: flex;
    align-items: center;
  }

  /* --- InputNumber (น้ำหนัก / ขนาด) --- */
  .ant-form-item .ant-input-number,
  .parcel-field-number.ant-input-number {
    width: 100%;
    height: ${PARCEL_FIELD_HEIGHT}px;
  }

  .ant-form-item .ant-input-number .ant-input-number-input,
  .parcel-field-number.ant-input-number .ant-input-number-input {
    height: ${PARCEL_FIELD_HEIGHT - 2}px;
  }

  /* --- เบอร์โทร + ปุ่มค้นหา (Input.Group) --- */
  .ant-input-group-wrapper .ant-input-group .ant-input {
    height: ${PARCEL_FIELD_HEIGHT}px;
  }

  .ant-input-group-wrapper .ant-input-group-addon .ant-btn {
    height: ${PARCEL_FIELD_HEIGHT}px;
    line-height: ${PARCEL_FIELD_HEIGHT - 2}px;
    padding-top: 0;
    padding-bottom: 0;
    display: inline-flex;
    align-items: center;
  }

  /* เบอร์โทร + ปุ่มค้นหา / เพิ่มที่อยู่ (ต่อท้าย input) */
  .parcel-field-input-with-phone-actions.ant-input-group-wrapper .ant-input-group-addon {
    padding: 0;
    background: transparent;
    border: none;
  }

  .parcel-phone-actions {
    display: inline-flex;
    align-items: stretch;
    gap: 6px;
    margin-left: 6px;
  }

  .parcel-phone-actions .ant-btn {
    height: ${PARCEL_FIELD_HEIGHT}px;
    line-height: ${PARCEL_FIELD_HEIGHT - 2}px;
    padding-top: 0;
    padding-bottom: 0;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
  }

  /* --- ยกเว้น: ช่องที่อยู่ (คงความสูงตาม rows) --- */
  .parcel-field-address-textarea.ant-input-textarea textarea.ant-input {
    height: auto !important;
    min-height: auto !important;
  }

  /* Input ที่มี showCount — อย่าบังคับความสูงตายตัว (กันเส้นล่างถูกบัง) */
  .parcel-field-input-count.ant-input-affix-wrapper {
    height: auto !important;
    min-height: ${PARCEL_FIELD_HEIGHT}px;
    padding-bottom: 20px;
  }

  .parcel-field-input-count.ant-input-affix-wrapper > input.ant-input {
    height: ${PARCEL_FIELD_HEIGHT}px;
  }

  /* Input มี allowClear — อย่าบังคับความสูงตายตัว (กันเส้นล่างถูกบัง) */
  .parcel-field-input-affix.ant-input-affix-wrapper {
    height: auto !important;
    min-height: ${PARCEL_FIELD_HEIGHT}px;
  }

  .parcel-field-input-affix.ant-input-affix-wrapper > input.ant-input {
    height: ${PARCEL_FIELD_HEIGHT}px;
  }

  /* TextArea มี showCount (หมายเหตุ) */
  .parcel-field-textarea-count.ant-input-textarea-show-count {
    padding-bottom: 22px;
  }

  .parcel-field-textarea-count textarea.ant-input {
    height: auto !important;
    min-height: auto !important;
  }

  .ant-btn {
    font-size: 12px;
    font-weight: 400 !important;
  }

  .parcel-create-parcel-btn.ant-btn {
    height: 38px;
    min-height: 38px;
    padding: 4px 24px;
    line-height: 22px;
  }
`;
